import { Component, Input } from '@angular/core';
import { TicketDto } from '../../../../../service/dto';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
	selector: 'app-ticket-duplicate-warning-modal',
	standalone: false,
	templateUrl: './ticket-duplicate-warning-modal.component.html',
	styleUrl: './ticket-duplicate-warning-modal.component.scss'
})
export class TicketDuplicateWarningModalComponent {
	@Input() tickets!: TicketDto[];

	constructor(private modal: NzModalRef) { }

	openTicket(ticket: TicketDto): void {
		const url = `ticket/${ticket.ticketMode}/${ticket.id}`;   // adjust to your route structure
		window.open(url, '_blank');
	}

	cancel(): void {
		this.modal.destroy(false);
	}

	continue(): void {
		this.modal.destroy(true);
	}
}
